
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import GoogleMaps from '../../anonymous/GoogleMaps.vue';

import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import SwitchField from '../../../../framework/fields/SwitchField.vue';

import { sharedState } from '../../../../framework/state';
import { getResource, postResource, putResource } from '../../../../framework/client/resource';
import { getDatabaseOptions, OptionValue } from '../../../../framework/service/options';

import { getCustomerOptions } from '../../../service/application_options_service';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

import { errorToast, successToast } from '../../../service/toast_service';
import { NotificationRecipient } from '../../../../../common/application/model/NotificationRecipient';
import AutoCompleteMultipleField from '../../../fields/AutoCompleteMultipleField.vue';
import EmailField from '../../../../framework/fields/EmailField.vue';
import PhoneField from '../../../../framework/fields/PhoneField.vue';

@Component({
    components: {
        PhoneField,
        EmailField,
        AutoCompleteMultipleField,
        SwitchField,
        SelectField,
        TextField,
        GoogleMaps,
        ValidationObserver,
    },
})
export default class EditNotificationRecipient extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.NOTIFICATION_RECIPIENT;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        loading: false,
        selectedCustomer: [] as string[],
        selectedVehicleContract: [] as string[],
        row: {} as NotificationRecipient,
        customerOptions: [] as OptionValue[],
        notificationTypeOptions: [] as OptionValue[],
        localeOptions: [
            { id: 'fi', label: 'Suomi' },
            { id: 'en', label: 'English' },
        ],
    };

    // Functions
    async mounted() {
        await this.loadAsyncData();
    }

    dropdownClosed(resourceIds: string[], idField: string): void {
        if (this.local.loading) {
            return;
        }

        this.local.row = {
            ...this.local.row,
            [idField]: resourceIds[0],
        };
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    back() {
        this.$router.go(-1);
    }

    async saveResource(goBack: boolean) {
        try {
            await putResource<NotificationRecipient>(this.resourceType, this.id, this.local.row);
            successToast(this, 'message.saved');

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    vehicleRegistrationNumberParameters(): Map<string, any> {
        if (this.local.row.customerId) {
            return new Map<string, any>([['customerId', [this.local.row.customerId]]]);
        }

        if (this.isAdmin) {
            return new Map<string, any>();
        }

        return new Map<string, any>([['customerId', this.local.customerOptions.map(({ id }) => id)]]);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    private async loadAsyncData(): Promise<void> {
        this.local.loading = true;

        this.local.row = (await getResource<NotificationRecipient>(this.resourceType, this.id))!!;
        this.local.customerOptions = await getCustomerOptions();
        this.local.notificationTypeOptions = await getDatabaseOptions('NotificationType', this);

        if (this.local.row.customerId) {
            this.local.selectedCustomer = [this.local.row.customerId];
        }

        if (this.local.row.vehicleContractId) {
            this.local.selectedVehicleContract = [this.local.row.vehicleContractId];
        }

        this.local.loading = false;
    }
}
